import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "ml-s" }
const _hoisted_2 = { class: "ml-s" }
const _hoisted_3 = {
  key: 0,
  class: "mb-m"
}
const _hoisted_4 = {
  key: 0,
  class: "mt-m"
}
const _hoisted_5 = { class: "mr-s" }
const _hoisted_6 = { key: 2 }

import { computed, ref } from "vue";

import { useOrdersStore } from "@/store/ordersStore";
import { MedicationOrderBoxStatus } from "@/interfaces/enum/medicationOrderStatus";
import { BoxWithOrders, Message } from "@/interfaces/message";
import { Conversation } from "@/interfaces/conversation";
import { updateMessage } from "@/helpers/requestHelpers/ordersRequests";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import UButton from "@/components/UButton.vue";
import RoundedCard from "@/components/RoundedCard.vue";
import QrScanner from "../components/QrScanner.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import CoreIcon from "@/components/CoreIcon.vue";
import SmallTag from "@/components/SmallTag.vue";
import DialogCard from "@/components/DialogCard.vue";
import { useNotificationStore } from "@/store/notificationStore";
import IconButton from "@/components/IconButton.vue";
import { isBoxDue } from "@/helpers/orderhelper";
import { localeDateString } from "@/helpers/datehelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersScanner',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const confirmModal = ref<boolean>(false);
const orderStore = useOrdersStore();
const history = ref<Set<number>>(new Set());
const loading = ref<Set<number>>(new Set());
const emits = __emit;

const scannedData = ref<{
  conversation?: Conversation;
  box?: Message;
  status?: number;
  boxWithDetails?: BoxWithOrders;
}>({});

const uncheckedItems = computed<Message[]>(() => {
  if (scannedData.value.box) {
    return [
      ...(boxDetails(scannedData.value.box.id)?.fridge ?? []),
      ...(boxDetails(scannedData.value.box.id)?.safe ?? []),
    ];
  } else {
    return [];
  }
});

const confirmUpdateBoxText = computed<string>(() => {
  return uncheckedItems.value.length > 0
    ? "Kiste trotzdem aktualisieren"
    : "Kiste aktualisieren";
});

async function updateBox(
  conversation: Conversation,
  box: Message,
  _changes: Map<string, any>
) {
  loading.value.add(box.id);
  await updateMessage(conversation, box, _changes);
  loading.value.delete(box.id);
}
async function check(box: Message) {
  if (scannedData.value.conversation) {
    await updateMessage(
      scannedData.value.conversation,
      box,
      new Map([["storage_location", 0]])
    );
  }
}

async function scannedQr(
  text: string,
  status: number
): Promise<{ msg: string; success: boolean }> {
  window._paq.push(["trackEvent", "OrdersScanner", "scanned", undefined]);

  // umanabox-${props.conversation.id}-${box.id}

  let splittedText = text.split("-");
  if (splittedText.length != 3) {
    return { success: false, msg: "Fehler. Ungültiger QR-Code #301" };
  }
  if (splittedText[0] != "umanabox") {
    return { success: false, msg: "Fehler. Ungültiger QR-Code #302" };
  }
  let conversationId = parseInt(splittedText[1]);
  let boxId = parseInt(splittedText[2]);
  let conversation = orderStore.conversations?.get(conversationId);
  let box = orderStore.messages?.get(boxId);
  if (!box) {
    return { success: false, msg: "Fehler. Ungültiger QR-Code #303" };
  }
  if (!conversation || conversation === undefined) {
    return { success: false, msg: "Fehler. Ungültiger QR-Code #304" };
  }

  const boxWithDetails = boxDetails(box.id);
  if (boxWithDetails) {
    scannedData.value = {
      conversation,
      box,
      status,
      boxWithDetails,
    };
    if (
      boxWithDetails.fridge.length == 0 &&
      boxWithDetails.safe.length == 0 &&
      isBoxDue(boxWithDetails)
    ) {
      await confirmUpdateBox();
    } else {
      confirmModal.value = true;
    }
  }
  return {
    success: true,
    msg: "",
  };
}

async function confirmUpdateBox() {
  if (
    scannedData.value.conversation &&
    scannedData.value.box &&
    scannedData.value.status
  ) {
    await updateBox(
      scannedData.value.conversation,
      scannedData.value.box,
      new Map([["status", scannedData.value.status]])
    );

    useNotificationStore().removeNotificationsWithId("scanner");
    useNotificationStore().notifications.push({
      msg: `${
        scannedData.value.box.medication_box?.name ?? "unbenannte Kiste"
      } (#${scannedData.value.box.id}) aktualisiert. Neuer Status: ${
        MedicationOrderBoxStatus.find((s) => s.id == scannedData.value.status)
          ?.name
      }`,
      type: "success",
      customId: "scanner",
    });
    confirmModal.value = false;
  }
}

function boxDetails(boxId: number): BoxWithOrders | undefined {
  const boxWithDetails = useOrdersStore().organizedBoxes.find(
    (box) => box.id == boxId
  );

  return boxWithDetails;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(RoundedCard, { color: "white" }, {
      default: _withCtx(() => [
        _createVNode(UmanaHeadline, {
          h: "h2",
          class: "mb-s justify-between"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Scanner")
          ]),
          _: 1
        }),
        _createVNode(QrScanner, {
          class: "m-auto",
          "request-status": true,
          onQrScanned: scannedQr
        }),
        _createVNode(UButton, {
          class: "m-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Kamera Beenden ")
          ]),
          _: 1
        }),
        (loading.value.size > 0 || history.value.size > 0)
          ? (_openBlock(), _createBlock(UmanaHeadline, {
              key: 0,
              h: "h3",
              class: "mb-m mt-s justify-between"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Gescannte Kisten ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loading.value, (boxId) => {
          return (_openBlock(), _createElementBlock("div", {
            key: boxId,
            class: "flex"
          }, [
            _createVNode(LoadingSpinner),
            _createElementVNode("div", _hoisted_1, "Box #" + _toDisplayString(boxId), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (boxId) => {
          return (_openBlock(), _createElementBlock("div", {
            key: boxId,
            class: "flex"
          }, [
            _createVNode(CoreIcon, { icon: "check" }),
            _createElementVNode("div", _hoisted_2, "Box #" + _toDisplayString(boxId), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(DialogCard, {
      "is-visible": confirmModal.value,
      title: "Kiste aktualisieren",
      "show-footer": true,
      confirm: confirmUpdateBoxText.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (confirmModal.value = false)),
      onSubmit: confirmUpdateBox
    }, {
      default: _withCtx(() => [
        (
          scannedData.value.boxWithDetails && !_unref(isBoxDue)(scannedData.value.boxWithDetails)
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (scannedData.value.boxWithDetails.due)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Vorsicht: Das Lieferdatum dieser Kiste weicht ab (" + _toDisplayString(_unref(localeDateString)(scannedData.value.boxWithDetails.due ?? "")) + "). Möchten Sie den Status trotzdem aktualisieren? ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Vorsicht: Diese Kiste hat kein Lieferdatum. Möchten Sie den Status trotzdem aktualisieren? ")
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (uncheckedItems.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Bitte beachten Sie folgende Produkte, die sich ausserhalb der Kiste befinden: "),
              (scannedData.value.box)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uncheckedItems.value, (product) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: product.id,
                        class: "flex items-center mt-xs justify-between"
                      }, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(product.medication_order?.amount ?? 0) + "x " + _toDisplayString(product.medication_order?.name ?? "k.A."), 1),
                        (product.medication_order?.storage_location == 1)
                          ? (_openBlock(), _createBlock(SmallTag, {
                              key: 0,
                              color: "purple",
                              small: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Kühlschrank ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (product.medication_order?.storage_location == 2)
                          ? (_openBlock(), _createBlock(SmallTag, {
                              key: 1,
                              color: "pink",
                              small: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Tresor ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(IconButton, {
                          icon: "check",
                          onClick: ($event: any) => (check(product))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (
          scannedData.value.boxWithDetails && _unref(isBoxDue)(scannedData.value.boxWithDetails)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Es wurden alle Produkte kontrolliert. Sie können die Kiste nun aktualisieren, falls Sie möchten. "),
                _createVNode(UButton, {
                  class: "block m-auto my-l",
                  onClick: confirmUpdateBox
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Kiste aktualisieren")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-visible", "confirm"])
  ]))
}
}

})